export default __webpack_public_path__ + "static/hero-video-bg-f492ecd514cf678b52b5d76c7912f88d.mp4";